import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ProgressNotesListPage } from '@/features/scheduler/pages/progress-notes-list-page'

const progressNotesSearchSchema = z.object({
  page: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  search: z.string().optional(),
  mood: z.string().optional(),
  noteType: z.string().optional(),
  noteId: z.string().optional(),
  /**
   * Service day the note is ABOUT (org timezone), `YYYY-MM-DD`. Sent to the API as
   * `serviceDate` — the URL keeps the shorter `day` because it is hand-editable.
   */
  day: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  /** Participant filter. */
  clientId: z.string().uuid().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/progress-notes'
)({
  component: ProgressNotesListPage,
  validateSearch: progressNotesSearchSchema,
})
